import { trackEvent } from '@farmnet/tag-manager';

angular.module('cfn').controller('livestockController', livestockController);

livestockController.$inject = [
  '$scope'
];
function livestockController(
  $scope
) {
  $scope.hasRight = app.hasRight;
  $scope.hasFunctionalAnalysisRight = app.hasRight('Company:FUNCTIONAL_ANALYSIS');
  $scope.hasCompanyPlanningRight = app.hasRight('Company:PLANNING');
  $scope.hasPreliminaryBookingRight = app.hasRight(
      'Company:PRELIMINARY_BOOKING'
  );

  $scope.state = {};

  $scope.trackLivestockNavigation = (title) => {
    const navigationLabel = `LiveStock::${title}`;

    trackEvent('Navigation', 'Body', navigationLabel);
  };

  return ($scope.livestockController = this);
}
export default livestockController;
